import { Route, Routes } from "react-router-dom";
import { Layout } from "./components/Layout";
import { AccountPage } from "./pages/AccountPage";
import { CustomerModelPredictPage } from "./pages/CustomerModelPredictPage";
import { FavoritesPage } from "./pages/FavoritesPage";
import { ForgotPasswordPage } from "./pages/ForgotPasswordPage";
import { HomePage } from "./pages/HomePage";
import { LoginPage } from "./pages/LoginPage";
import { MarketingPage } from "./pages/MarketingPage";
import { ModelRunPage } from "./pages/ModelRunPage";
import { OAuthCallbackPage } from "./pages/OAuthCallbackPage";
import { RegisterPage } from "./pages/RegisterPage";
import { ResetPasswordPage } from "./pages/ResetPasswordPage";

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="models/predict" element={<CustomerModelPredictPage />} />
        <Route path="ai-models/run/:modelId" element={<ModelRunPage />} />
        <Route path="account" element={<AccountPage />} />
        <Route path="account/login" element={<LoginPage />} />
        <Route path="account/register" element={<RegisterPage />} />
        <Route path="account/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="account/reset-password" element={<ResetPasswordPage />} />
        <Route path="account/oauth/callback" element={<OAuthCallbackPage />} />
        <Route path="account/favorites" element={<FavoritesPage />} />
        <Route path=":section" element={<MarketingPage />} />
        <Route path=":section/:subsection" element={<MarketingPage />} />
      </Route>
    </Routes>
  );
}
